import DtoPiezoMeasureLight from '../../../piezometry/dto/chart/DtoPiezoMeasureLight'

export default class DtoPiezometerAdditionalMeasures {
    constructor(object) {
        this.type = object.type
        this.measures = object.measures.map(m => new DtoPiezoMeasureLight(m))
    }
}
